var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "dynamic-form-editor"
  }, [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.editorTitle) + " "), _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": _vm.exportSubjects
    }
  }, [_vm._v(" 匯出 JSON ")]), _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": _vm.importSubjects
    }
  }, [_vm._v(" 匯入 JSON ")])], 1), _c('section', {
    staticClass: "dynamic-form-editor__subjects"
  }, [_c('VueDraggable', {
    attrs: {
      "handle": ".subject-layout-drag-handler",
      "list": _vm.newSubjects,
      "disabled": _vm.isReadOnly
    }
  }, _vm._l(_vm.newSubjects, function (newSubject, index) {
    return _c('b-card', {
      key: "".concat(_vm.newSubjects[index]._id, "_").concat(_vm.rerenderingCount, "_").concat(_vm.validateSubject),
      staticClass: "mt-3"
    }, [_c('SubjectLayout', {
      ref: 'subjectLayoutRef+' + _vm.newSubjects[index]._id,
      refInFor: true,
      attrs: {
        "id": "subject-".concat(_vm.newSubjects[index]._id),
        "index": index,
        "type": newSubject.type,
        "title": _vm.newSubjects[index].title,
        "memo": _vm.newSubjects[index].memo,
        "assign-to-customer-data": _vm.newSubjects[index].assign_to_customer_data,
        "save-to-customer-data": _vm.newSubjects[index].save_to_customer_data,
        "placeholder": _vm.newSubjects[index].placeholder,
        "required": _vm.newSubjects[index].required,
        "validation-rules": _vm.newSubjects[index].validation_rules,
        "dashboardOnly": _vm.newSubjects[index].dashboard_only,
        "mainDisplay": _vm.newSubjects[index].main_display,
        "move-up-is-disabled": index == 0,
        "move-down-is-disabled": index == _vm.newSubjects.length - 1,
        "has-placeholder": ['text', 'textarea', 'select', 'datetime', 'collection_carousel'].includes(newSubject.type),
        "expanded": _vm.expandedStateForSubjects[_vm.newSubjects[index]._id],
        "form-type": _vm.formType,
        "listHidden": _vm.newSubjects[index].list_hidden,
        "readonly": _vm.isReadOnly,
        "title-is-editable": false === _vm.subjectIsFixed(_vm.newSubjects[index]),
        "expand-button-is-visible": false === _vm.subjectIsFixed(_vm.newSubjects[index]),
        "is-deletable": false === _vm.subjectIsFixed(_vm.newSubjects[index]),
        "page": _vm.newSubjects[index].page_id,
        "page-options": _vm.pages,
        "section": _vm.newSubjects[index].section_id,
        "section-options": _vm.sections,
        "visible-conditions": _vm.newSubjects[index].visible_when_any,
        "field-options-for-visible-conditions": _vm.inputSubjects,
        "validate": _vm.validateSubject,
        "validation-message": "\u7B2C".concat(index + 1, "\u984C ").concat(_vm.validationMessage)
      },
      on: {
        "update:title": function updateTitle($event) {
          return _vm.$set(_vm.newSubjects[index], "title", $event);
        },
        "update:memo": function updateMemo($event) {
          return _vm.$set(_vm.newSubjects[index], "memo", $event);
        },
        "update:assignToCustomerData": function updateAssignToCustomerData($event) {
          return _vm.$set(_vm.newSubjects[index], "assign_to_customer_data", $event);
        },
        "update:assign-to-customer-data": function updateAssignToCustomerData($event) {
          return _vm.$set(_vm.newSubjects[index], "assign_to_customer_data", $event);
        },
        "update:saveToCustomerData": function updateSaveToCustomerData($event) {
          return _vm.$set(_vm.newSubjects[index], "save_to_customer_data", $event);
        },
        "update:save-to-customer-data": function updateSaveToCustomerData($event) {
          return _vm.$set(_vm.newSubjects[index], "save_to_customer_data", $event);
        },
        "update:placeholder": function updatePlaceholder($event) {
          return _vm.$set(_vm.newSubjects[index], "placeholder", $event);
        },
        "update:required": function updateRequired($event) {
          return _vm.$set(_vm.newSubjects[index], "required", $event);
        },
        "update:validationRules": function updateValidationRules($event) {
          return _vm.$set(_vm.newSubjects[index], "validation_rules", $event);
        },
        "update:validation-rules": function updateValidationRules($event) {
          return _vm.$set(_vm.newSubjects[index], "validation_rules", $event);
        },
        "update:dashboardOnly": function updateDashboardOnly($event) {
          return _vm.$set(_vm.newSubjects[index], "dashboard_only", $event);
        },
        "update:dashboard-only": function updateDashboardOnly($event) {
          return _vm.$set(_vm.newSubjects[index], "dashboard_only", $event);
        },
        "update:mainDisplay": function updateMainDisplay($event) {
          return _vm.$set(_vm.newSubjects[index], "main_display", $event);
        },
        "update:main-display": function updateMainDisplay($event) {
          return _vm.$set(_vm.newSubjects[index], "main_display", $event);
        },
        "update:expanded": function updateExpanded($event) {
          return _vm.$set(_vm.expandedStateForSubjects, _vm.newSubjects[index]._id, $event);
        },
        "update:listHidden": function updateListHidden($event) {
          return _vm.$set(_vm.newSubjects[index], "list_hidden", $event);
        },
        "update:list-hidden": function updateListHidden($event) {
          return _vm.$set(_vm.newSubjects[index], "list_hidden", $event);
        },
        "update:page": function updatePage($event) {
          return _vm.$set(_vm.newSubjects[index], "page_id", $event);
        },
        "update:section": function updateSection($event) {
          return _vm.$set(_vm.newSubjects[index], "section_id", $event);
        },
        "update:visibleConditions": function updateVisibleConditions($event) {
          return _vm.$set(_vm.newSubjects[index], "visible_when_any", $event);
        },
        "update:visible-conditions": function updateVisibleConditions($event) {
          return _vm.$set(_vm.newSubjects[index], "visible_when_any", $event);
        },
        "top": function top($event) {
          return _vm.moveToTop(index);
        },
        "up": function up($event) {
          return _vm.moveUp(index);
        },
        "down": function down($event) {
          return _vm.moveDown(index);
        },
        "bottom": function bottom($event) {
          return _vm.moveToBottom(index);
        },
        "remove": function remove($event) {
          return _vm.removeNewSubject(index);
        }
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function fn() {
          return [['radio', 'checkbox', 'select'].includes(newSubject.type) ? _c('b-form-group', [_c('div', {
            staticClass: "option-list-header"
          }, [_c('div', {
            staticClass: "option-list-header__title",
            staticStyle: {
              "width": "13rem",
              "padding-left": "2rem"
            }
          }, [_vm._v("選項文字")]), _c('div', {
            staticClass: "option-list-header__title ml-2",
            staticStyle: {
              "width": "8rem"
            }
          }, [_vm._v("管理")]), _c('div', {
            staticClass: "option-list-header__title ml-2",
            staticStyle: {
              "width": "5rem"
            }
          }, [_vm._v("前台隱藏")])]), _c('div', {
            staticClass: "mt-3"
          }, [_c('VueDraggable', {
            attrs: {
              "handle": ".option-drag-handler",
              "list": _vm.newSubjects[index].options,
              "disabled": _vm.isReadOnly
            }
          }, _vm._l(_vm.newSubjects[index].options, function (option, optionIndex) {
            return _c('div', {
              key: index + '-opt-' + optionIndex,
              staticClass: "mb-3 d-flex align-items-center"
            }, [_c('div', {
              staticClass: "flex-grow-0 flex-shrink-0 d-flex align-items-center",
              staticStyle: {
                "width": "13rem"
              }
            }, [_c('i', {
              staticClass: "fa fa-bars mr-3 option-drag-handler"
            }), _c('b-form-input', {
              ref: "".concat(newSubject._id, "_").concat(optionIndex),
              refInFor: true,
              attrs: {
                "placeholder": "請輸入選項",
                "disabled": _vm.isReadOnly
              },
              on: {
                "change": function change($event) {
                  return _vm.syncOptionValue(index, optionIndex);
                },
                "compositionstart": _vm.compositionStart,
                "compositionend": function compositionend($event) {
                  return _vm.compositionEnd(index, optionIndex);
                },
                "keydown": function keydown($event) {
                  if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
                  return function (event) {
                    return _vm.handleKeyDown({
                      event: event,
                      subjectIndex: index,
                      optionIndex: optionIndex,
                      id: newSubject._id
                    });
                  }.apply(null, arguments);
                },
                "paste": function paste(e) {
                  return _vm.handlePaste(e, index, optionIndex);
                }
              },
              model: {
                value: _vm.newSubjects[index].options[optionIndex].text,
                callback: function callback($$v) {
                  _vm.$set(_vm.newSubjects[index].options[optionIndex], "text", $$v);
                },
                expression: "newSubjects[index].options[optionIndex].text"
              }
            })], 1), !_vm.isReadOnly ? _c('div', {
              staticClass: "flex-grow-0 flex-shrink-0 ml-2",
              staticStyle: {
                "width": "8rem"
              }
            }, [_c('b-button', {
              staticClass: " p-1 d-inline-flex align-items-center",
              attrs: {
                "variant": "inverse-success"
              },
              on: {
                "click": function click($event) {
                  return _vm.createOption(optionIndex, newSubject._id);
                }
              }
            }, [_c('span', {
              staticClass: "mdi mdi-18px mdi-playlist-plus"
            }), _vm._v(" 增加 ")]), _c('b-button', {
              staticClass: "ml-2 p-1 d-inline-flex align-items-center",
              attrs: {
                "variant": "inverse-danger",
                "disabled": _vm.isOnlyOneOption(index)
              },
              on: {
                "click": function click($event) {
                  return _vm.removeOption(index, optionIndex);
                }
              }
            }, [_c('span', {
              staticClass: "mdi mdi-18px mdi-playlist-remove"
            }), _vm._v(" 移除 ")])], 1) : _vm._e(), !_vm.isReadOnly ? _c('div', {
              staticClass: "flex-grow-0 flex-shrink-0 ml-2",
              staticStyle: {
                "width": "5rem"
              }
            }, [_c('b-form-checkbox', {
              model: {
                value: _vm.newSubjects[index].options[optionIndex].staff_only,
                callback: function callback($$v) {
                  _vm.$set(_vm.newSubjects[index].options[optionIndex], "staff_only", $$v);
                },
                expression: "newSubjects[index].options[optionIndex].staff_only"
              }
            })], 1) : _vm._e()]);
          }), 0)], 1)]) : _vm._e(), newSubject.type === 'datetime' ? [_c('b-form-group', {
            attrs: {
              "label": "格式 *",
              "label-size": "sm",
              "disabled": _vm.isReadOnly
            }
          }, [_c('b-form-radio-group', {
            staticClass: "input-group",
            attrs: {
              "options": [{
                text: '日期 + 時間',
                value: 'datetime'
              }, {
                text: '日期',
                value: 'date'
              }, {
                text: '時間',
                value: 'time'
              }]
            },
            on: {
              "change": function change($event) {
                return _vm.handleFieldChange(_vm.newSubjects[index], 'format');
              }
            },
            model: {
              value: _vm.newSubjects[index].format,
              callback: function callback($$v) {
                _vm.$set(_vm.newSubjects[index], "format", $$v);
              },
              expression: "newSubjects[index].format"
            }
          })], 1), _vm.isInclude('date', _vm.newSubjects[index].format) ? _c('b-overlay', {
            staticClass: "mt-2"
          }, [_c('b-form-group', {
            attrs: {
              "label": "日期格式 *",
              "label-size": "sm",
              "disabled": _vm.isReadOnly,
              "clsss": "mt-2"
            }
          }, [_c('b-form-radio-group', {
            on: {
              "change": function change($event) {
                return _vm.changeDateCondition($event, index);
              }
            },
            model: {
              value: _vm.newSubjects[index].date_condition,
              callback: function callback($$v) {
                _vm.$set(_vm.newSubjects[index], "date_condition", $$v);
              },
              expression: "newSubjects[index].date_condition"
            }
          }, [_c('b-form-radio', {
            attrs: {
              "value": "unlimited"
            }
          }, [_vm._v(" 自行選擇日期 ")]), _c('span', {
            staticClass: "d-inline-block",
            attrs: {
              "id": "limited-date-wrap-".concat(newSubject._id)
            }
          }, [_c('b-form-radio', {
            attrs: {
              "value": "limited",
              "disabled": _vm.bookingPresetType === 'wizard' && _vm.startAtFieldId === newSubject._id
            }
          }, [_vm._v(" 特定日期 ")])], 1), _vm.bookingPresetType === 'wizard' && _vm.startAtFieldId === newSubject._id ? _c('b-tooltip', {
            attrs: {
              "target": "limited-date-wrap-".concat(newSubject._id),
              "triggers": "hover focus"
            }
          }, [_vm._v(" 精靈模式尚未支援特定日期 ")]) : _vm._e()], 1)], 1), _c('b-form-group', {
            attrs: {
              "label": "日期呈現樣式",
              "label-size": "sm",
              "disabled": "",
              "clsss": "mt-2"
            }
          }, [_c('b-form-radio-group', {
            attrs: {
              "options": [{
                text: '日曆下拉',
                value: 'calendar_style'
              }, {
                text: '日期下拉',
                value: 'select_style'
              }]
            },
            model: {
              value: _vm.newSubjects[index].date_style,
              callback: function callback($$v) {
                _vm.$set(_vm.newSubjects[index], "date_style", $$v);
              },
              expression: "newSubjects[index].date_style"
            }
          })], 1)], 1) : _vm._e(), _vm.isInclude('time', _vm.newSubjects[index].format) ? _c('b-overlay', {
            staticClass: "mt-2"
          }, [_c('b-form-group', {
            staticClass: "mt-2",
            attrs: {
              "label": "時間格式 *",
              "label-size": "sm",
              "disabled": _vm.isReadOnly
            }
          }, [_c('b-form-radio-group', {
            staticClass: "input-group",
            attrs: {
              "options": [{
                text: '自行選擇時間',
                value: 'unlimited'
              }, {
                text: '連續時間',
                value: 'limited'
              }, {
                text: '特定時間',
                value: 'specified'
              }]
            },
            on: {
              "change": function change($event) {
                return _vm.handleTimeConditionChange($event, index);
              }
            },
            model: {
              value: _vm.newSubjects[index].time_condition,
              callback: function callback($$v) {
                _vm.$set(_vm.newSubjects[index], "time_condition", $$v);
              },
              expression: "newSubjects[index].time_condition"
            }
          })], 1), _c('b-form-group', {
            attrs: {
              "label": "時間呈現樣式",
              "label-size": "sm",
              "disabled": _vm.isReadOnly,
              "clsss": "mt-2"
            }
          }, [_c('b-form-radio-group', {
            attrs: {
              "options": [{
                text: '時間下拉',
                value: 'time_select_style',
                disabled: true
              }, {
                text: '自訂下拉',
                value: 'select_style',
                disabled: _vm.newSubjects[index].time_condition === 'unlimited'
              }, {
                text: '內嵌時間',
                value: 'button_style',
                disabled: _vm.newSubjects[index].time_condition === 'unlimited'
              }]
            },
            model: {
              value: _vm.newSubjects[index].time_style,
              callback: function callback($$v) {
                _vm.$set(_vm.newSubjects[index], "time_style", $$v);
              },
              expression: "newSubjects[index].time_style"
            }
          })], 1), _vm.isInclude('datetime', _vm.newSubjects[index].format) ? _c('b-form-group', {
            attrs: {
              "label": "時段設定",
              "label-size": "sm",
              "disabled": _vm.isReadOnly,
              "clsss": "mt-2"
            }
          }, [_c('b-form-radio-group', {
            attrs: {
              "options": [{
                text: '每日固定時段',
                value: 'daily_fixed_time',
                disabled: _vm.newSubjects[index].time_condition !== 'specified'
              }, {
                text: '依日期調整時段',
                value: 'daily_flexible_time',
                disabled: _vm.newSubjects[index].time_condition !== 'specified'
              }]
            },
            on: {
              "change": function change($event) {
                return _vm.handleDailyTimeChange(_vm.newSubjects[index].daily_time, index);
              }
            },
            model: {
              value: _vm.newSubjects[index].daily_time,
              callback: function callback($$v) {
                _vm.$set(_vm.newSubjects[index], "daily_time", $$v);
              },
              expression: "newSubjects[index].daily_time"
            }
          })], 1) : _vm._e()], 1) : _vm._e(), _vm.isInclude('date', _vm.newSubjects[index].format) ? [_vm.newSubjects[index].date_condition == 'limited' ? _c('b-form-group', {
            attrs: {
              "label": "",
              "label-size": "sm"
            }
          }, [_c('div', {
            staticClass: "mt-3"
          }, [_c('VueDraggable', {
            attrs: {
              "handle": ".option-drag-handler",
              "list": _vm.newSubjects[index].options,
              "disabled": _vm.isReadOnly
            }
          }, _vm._l(_vm.newSubjects[index].options, function (option, optionIndex) {
            return _c('b-card', {
              key: index + '-opt-' + optionIndex,
              staticClass: "mb-3 rounded rounded-2 shadow-none",
              attrs: {
                "bg-variant": "light",
                "no-body": ""
              },
              scopedSlots: _vm._u([{
                key: "header",
                fn: function fn() {
                  return [_c('div', {
                    staticClass: "d-flex align-items-center"
                  }, [_c('div', {
                    staticClass: "d-flex align-items-center flex-fill"
                  }, [_c('i', {
                    staticClass: "fa fa-bars mr-3 option-drag-handler"
                  }), _c('AppDatePicker', {
                    ref: "".concat(newSubject._id, "_").concat(optionIndex),
                    refInFor: true,
                    attrs: {
                      "disabled": _vm.isReadOnly
                    },
                    model: {
                      value: _vm.newSubjects[index].options[optionIndex].value,
                      callback: function callback($$v) {
                        _vm.$set(_vm.newSubjects[index].options[optionIndex], "value", $$v);
                      },
                      expression: "newSubjects[index].options[optionIndex].value"
                    }
                  }), _c('b-form-input', {
                    staticClass: "ml-2",
                    staticStyle: {
                      "width": "200px"
                    },
                    attrs: {
                      "placeholder": "請填入顯示文字",
                      "disabled": _vm.isReadOnly
                    },
                    model: {
                      value: _vm.newSubjects[index].options[optionIndex].text,
                      callback: function callback($$v) {
                        _vm.$set(_vm.newSubjects[index].options[optionIndex], "text", $$v);
                      },
                      expression: "newSubjects[index].options[optionIndex].text"
                    }
                  })], 1), !_vm.isReadOnly ? _c('div', {
                    staticClass: "flex-shrink-0"
                  }, [_c('b-button', {
                    staticClass: "ml-2 p-1 d-inline-flex align-items-center",
                    attrs: {
                      "variant": "inverse-success"
                    },
                    on: {
                      "click": function click($event) {
                        return _vm.createOption(optionIndex, newSubject._id);
                      }
                    }
                  }, [_c('span', {
                    staticClass: "mdi mdi-18px mdi-playlist-plus"
                  }), _vm._v(" 增加 ")]), _c('b-button', {
                    staticClass: "ml-2 p-1 d-inline-flex align-items-center",
                    attrs: {
                      "variant": "inverse-danger",
                      "disabled": _vm.isOnlyOneOption(index)
                    },
                    on: {
                      "click": function click($event) {
                        return _vm.removeOption(index, optionIndex);
                      }
                    }
                  }, [_c('span', {
                    staticClass: "mdi mdi-18px mdi-playlist-remove"
                  }), _vm._v(" 移除 ")])], 1) : _vm._e()])];
                },
                proxy: true
              }], null, true)
            }, [_vm.newSubjects[index].daily_time == 'daily_flexible_time' ? _c('div', {
              staticClass: "pb-0 pt-3 pr-3 pl-5"
            }, [_c('VueDraggable', {
              attrs: {
                "handle": ".option-drag-handler",
                "list": _vm.newSubjects[index].options[optionIndex].time_options,
                "disabled": _vm.isReadOnly
              }
            }, _vm._l(_vm.newSubjects[index].options[optionIndex].time_options, function (option, timeOptionIndex) {
              return _c('div', {
                key: index + '-daily-time-opt-' + optionIndex + '-time-opt-' + timeOptionIndex,
                staticClass: "mb-3 d-flex align-items-center justify-content-between"
              }, [_c('div', {
                staticClass: "d-flex align-items-center justify-content-start"
              }, [_c('i', {
                staticClass: "fa fa-bars mr-3 option-drag-handler"
              }), _c('AppTimePicker', {
                attrs: {
                  "disabled": _vm.isReadOnly
                },
                model: {
                  value: _vm.newSubjects[index].options[optionIndex].time_options[timeOptionIndex].value,
                  callback: function callback($$v) {
                    _vm.$set(_vm.newSubjects[index].options[optionIndex].time_options[timeOptionIndex], "value", $$v);
                  },
                  expression: "newSubjects[index].options[optionIndex].time_options[timeOptionIndex].value"
                }
              }), _c('b-form-input', {
                staticClass: "ml-2",
                staticStyle: {
                  "width": "200px"
                },
                attrs: {
                  "placeholder": "請填入顯示文字",
                  "disabled": _vm.isReadOnly
                },
                model: {
                  value: _vm.newSubjects[index].options[optionIndex].time_options[timeOptionIndex].text,
                  callback: function callback($$v) {
                    _vm.$set(_vm.newSubjects[index].options[optionIndex].time_options[timeOptionIndex], "text", $$v);
                  },
                  expression: "newSubjects[index].options[optionIndex].time_options[timeOptionIndex].text"
                }
              })], 1), !_vm.isReadOnly ? _c('div', {
                staticClass: "d-flex"
              }, [_c('b-button', {
                staticClass: "ml-2 p-1 d-inline-flex align-items-center",
                attrs: {
                  "variant": "inverse-success"
                },
                on: {
                  "click": function click($event) {
                    return _vm.createDailyTimeOption(index, optionIndex, timeOptionIndex);
                  }
                }
              }, [_c('span', {
                staticClass: "mdi mdi-18px mdi-playlist-plus"
              }), _vm._v(" 增加 ")]), _c('b-button', {
                staticClass: "ml-2 p-1 d-inline-flex align-items-center",
                attrs: {
                  "variant": "inverse-danger",
                  "disabled": _vm.newSubjects[index].options[optionIndex].time_options.length === 1
                },
                on: {
                  "click": function click($event) {
                    return _vm.removeDailyTimeOption(index, optionIndex, timeOptionIndex);
                  }
                }
              }, [_c('span', {
                staticClass: "mdi mdi-18px mdi-playlist-remove"
              }), _vm._v(" 移除 ")])], 1) : _vm._e()]);
            }), 0)], 1) : _vm._e()]);
          }), 1)], 1)]) : _vm._e()] : _vm._e(), _vm.isInclude('time', _vm.newSubjects[index].format) && _vm.newSubjects[index].daily_time == 'daily_fixed_time' ? [_vm.newSubjects[index].time_condition == 'limited' ? _c('div', {
            attrs: {
              "clsss": "mt-2"
            }
          }, [_c('b-form-group', {
            attrs: {
              "label": "開始時間 *",
              "label-size": "sm",
              "disabled": _vm.isReadOnly,
              "clsss": "mt-2"
            }
          }, [_c('AppTimePicker', {
            model: {
              value: _vm.newSubjects[index].start_time,
              callback: function callback($$v) {
                _vm.$set(_vm.newSubjects[index], "start_time", $$v);
              },
              expression: "newSubjects[index].start_time"
            }
          })], 1), _c('b-form-group', {
            attrs: {
              "label": "結束時間 *",
              "label-size": "sm",
              "disabled": _vm.isReadOnly,
              "clsss": "mt-2"
            }
          }, [_c('AppTimePicker', {
            model: {
              value: _vm.newSubjects[index].end_time,
              callback: function callback($$v) {
                _vm.$set(_vm.newSubjects[index], "end_time", $$v);
              },
              expression: "newSubjects[index].end_time"
            }
          })], 1), _c('b-form-group', {
            attrs: {
              "label": "每個時間區段單位 *",
              "label-size": "sm",
              "disabled": _vm.isReadOnly,
              "clsss": "mt-2"
            }
          }, [_c('b-form-input', {
            model: {
              value: _vm.newSubjects[index].slot_minutes,
              callback: function callback($$v) {
                _vm.$set(_vm.newSubjects[index], "slot_minutes", $$v);
              },
              expression: "newSubjects[index].slot_minutes"
            }
          })], 1)], 1) : _vm._e(), _vm.newSubjects[index].time_condition == 'specified' ? _c('b-form-group', {
            attrs: {
              "label": "",
              "label-size": "sm"
            }
          }, [_c('div', {
            staticClass: "mt-3"
          }, [_c('VueDraggable', {
            attrs: {
              "handle": ".option-drag-handler",
              "list": _vm.newSubjects[index].time_options,
              "disabled": _vm.isReadOnly
            }
          }, _vm._l(_vm.newSubjects[index].time_options, function (option, optionIndex) {
            return _c('div', {
              key: index + '-time-opt-' + optionIndex,
              staticClass: "mb-3 d-flex align-items-center"
            }, [_c('div', {
              staticClass: "flex-grow-1 flex-shrink-1 d-flex align-items-center"
            }, [_c('i', {
              staticClass: "fa fa-bars mr-3 option-drag-handler"
            }), _c('AppTimePicker', {
              attrs: {
                "disabled": _vm.isReadOnly
              },
              model: {
                value: _vm.newSubjects[index].time_options[optionIndex].value,
                callback: function callback($$v) {
                  _vm.$set(_vm.newSubjects[index].time_options[optionIndex], "value", $$v);
                },
                expression: "newSubjects[index].time_options[optionIndex].value"
              }
            }), _c('b-form-input', {
              staticClass: "ml-2",
              staticStyle: {
                "width": "200px"
              },
              attrs: {
                "placeholder": "請填入顯示文字",
                "disabled": _vm.isReadOnly
              },
              model: {
                value: _vm.newSubjects[index].time_options[optionIndex].text,
                callback: function callback($$v) {
                  _vm.$set(_vm.newSubjects[index].time_options[optionIndex], "text", $$v);
                },
                expression: "newSubjects[index].time_options[optionIndex].text"
              }
            })], 1), !_vm.isReadOnly ? _c('div', {
              staticClass: "flex-shrink-0"
            }, [_c('b-button', {
              staticClass: "ml-2 p-1 d-inline-flex align-items-center",
              attrs: {
                "variant": "inverse-success"
              },
              on: {
                "click": function click($event) {
                  return _vm.createTimeOption(index, optionIndex);
                }
              }
            }, [_c('span', {
              staticClass: "mdi mdi-18px mdi-playlist-plus"
            }), _vm._v(" 增加 ")]), _c('b-button', {
              staticClass: "ml-2 p-1 d-inline-flex align-items-center",
              attrs: {
                "variant": "inverse-danger",
                "disabled": _vm.newSubjects[index].time_options.length === 1
              },
              on: {
                "click": function click($event) {
                  return _vm.removeTimeOption(index, optionIndex);
                }
              }
            }, [_c('span', {
              staticClass: "mdi mdi-18px mdi-playlist-remove"
            }), _vm._v(" 移除 ")])], 1) : _vm._e()]);
          }), 0)], 1)]) : _vm._e()] : _vm._e()] : _vm._e(), newSubject.type === 'collection_select' ? [_c('b-form-group', {
            attrs: {
              "label": "資料集關聯 *",
              "label-size": "sm",
              "disabled": _vm.isReadOnly
            }
          }, [_c('b-form-select', {
            attrs: {
              "options": _vm.collectionOptions
            },
            on: {
              "change": function change($event) {
                return _vm.handleCollectionSelectChange($event, _vm.newSubjects[index]._id);
              }
            },
            scopedSlots: _vm._u([{
              key: "first",
              fn: function fn() {
                return [_c('b-form-select-option', {
                  attrs: {
                    "value": null
                  }
                }, [_vm._v("請選擇資料集")])];
              },
              proxy: true
            }], null, true),
            model: {
              value: _vm.newSubjects[index].collection_id,
              callback: function callback($$v) {
                _vm.$set(_vm.newSubjects[index], "collection_id", $$v);
              },
              expression: "newSubjects[index].collection_id"
            }
          })], 1), _c('b-form-group', {
            attrs: {
              "label": "呈現方式",
              "label-size": "sm"
            }
          }, [_c('b-form-radio-group', {
            attrs: {
              "options": [{
                text: '下拉選單',
                value: 'select'
              }, {
                text: '單選題',
                value: 'radio'
              }, {
                text: '多選題',
                value: 'checkbox'
              }]
            },
            model: {
              value: _vm.newSubjects[index].collection_presentation,
              callback: function callback($$v) {
                _vm.$set(_vm.newSubjects[index], "collection_presentation", $$v);
              },
              expression: "newSubjects[index].collection_presentation"
            }
          })], 1), _c('b-form-group', {
            attrs: {
              "label-size": "sm",
              "disabled": _vm.isReadOnly
            },
            scopedSlots: _vm._u([{
              key: "label",
              fn: function fn() {
                return [_vm._v(" 分店關聯 "), _c('i', {
                  staticClass: "fa fa-question-circle ml-2 text-muted",
                  staticStyle: {
                    "font-size": "0.9rem"
                  },
                  attrs: {
                    "id": "branch-field-tooltip-select-".concat(index)
                  }
                })];
              },
              proxy: true
            }], null, true)
          }, [_c('b-form-select', {
            attrs: {
              "options": _vm.branchFieldOptions
            },
            model: {
              value: _vm.newSubjects[index].branch_field_id,
              callback: function callback($$v) {
                _vm.$set(_vm.newSubjects[index], "branch_field_id", $$v);
              },
              expression: "newSubjects[index].branch_field_id"
            }
          }), _c('b-tooltip', {
            attrs: {
              "target": "branch-field-tooltip-select-".concat(index),
              "triggers": "hover",
              "placement": "right"
            }
          }, [_vm._v(" 若資料集需與分店連動，請選擇分店欄位；若無需連動，則無須設定 ")])], 1)] : _vm._e(), newSubject.type === 'collection_carousel' ? [_c('b-form-group', {
            attrs: {
              "label": "資料集關聯 *",
              "label-size": "sm",
              "disabled": _vm.isReadOnly
            }
          }, [_c('b-form-select', {
            attrs: {
              "options": _vm.collectionOptions
            },
            on: {
              "input": function input(collectionId) {
                return _vm.handleCollectionCarouselChange(collectionId, _vm.newSubjects[index]);
              }
            },
            scopedSlots: _vm._u([{
              key: "first",
              fn: function fn() {
                return [_c('b-form-select-option', {
                  attrs: {
                    "value": null
                  }
                }, [_vm._v("請選擇資料集")])];
              },
              proxy: true
            }], null, true),
            model: {
              value: _vm.newSubjects[index].collection_id,
              callback: function callback($$v) {
                _vm.$set(_vm.newSubjects[index], "collection_id", $$v);
              },
              expression: "newSubjects[index].collection_id"
            }
          })], 1), _c('b-overlay', {
            attrs: {
              "show": _vm.isFetchCollectionFields[_vm.newSubjects[index].collection_id] === true
            }
          }, [_c('b-form-group', {
            attrs: {
              "label": "標題欄位",
              "label-size": "sm",
              "disabled": _vm.isReadOnly
            }
          }, [_c('b-form-select', {
            attrs: {
              "options": _vm.deepGet(_vm.collectionFieldOptions, _vm.newSubjects[index].collection_id, [])
            },
            on: {
              "input": function input(mappingFieldId) {
                return _vm.handleCollectionCarouselFieldMappingChange(mappingFieldId, _vm.newSubjects[index]);
              }
            },
            scopedSlots: _vm._u([{
              key: "first",
              fn: function fn() {
                return [_c('b-form-select-option', {
                  attrs: {
                    "value": null
                  }
                }, [_vm._v("請設定欄位對應")])];
              },
              proxy: true
            }], null, true),
            model: {
              value: _vm.newSubjects[index].collection_title,
              callback: function callback($$v) {
                _vm.$set(_vm.newSubjects[index], "collection_title", $$v);
              },
              expression: "newSubjects[index].collection_title"
            }
          })], 1), _c('b-form-group', {
            attrs: {
              "label": "圖片欄位",
              "label-size": "sm",
              "disabled": _vm.isReadOnly
            }
          }, [_c('b-form-select', {
            attrs: {
              "options": _vm.deepGet(_vm.collectionFieldOptions, _vm.newSubjects[index].collection_id, [])
            },
            on: {
              "input": function input(mappingFieldId) {
                return _vm.handleCollectionCarouselFieldMappingChange(mappingFieldId, _vm.newSubjects[index]);
              }
            },
            scopedSlots: _vm._u([{
              key: "first",
              fn: function fn() {
                return [_c('b-form-select-option', {
                  attrs: {
                    "value": null
                  }
                }, [_vm._v("請設定欄位對應")])];
              },
              proxy: true
            }], null, true),
            model: {
              value: _vm.newSubjects[index].collection_image,
              callback: function callback($$v) {
                _vm.$set(_vm.newSubjects[index], "collection_image", $$v);
              },
              expression: "newSubjects[index].collection_image"
            }
          })], 1), _c('b-form-group', {
            attrs: {
              "label": "說明欄位",
              "label-size": "sm",
              "disabled": _vm.isReadOnly
            }
          }, [_c('b-form-select', {
            attrs: {
              "options": _vm.deepGet(_vm.collectionFieldOptions, _vm.newSubjects[index].collection_id, [])
            },
            on: {
              "input": function input(mappingFieldId) {
                return _vm.handleCollectionCarouselFieldMappingChange(mappingFieldId, _vm.newSubjects[index]);
              }
            },
            scopedSlots: _vm._u([{
              key: "first",
              fn: function fn() {
                return [_c('b-form-select-option', {
                  attrs: {
                    "value": null
                  }
                }, [_vm._v("請設定欄位對應")])];
              },
              proxy: true
            }], null, true),
            model: {
              value: _vm.newSubjects[index].collection_description,
              callback: function callback($$v) {
                _vm.$set(_vm.newSubjects[index], "collection_description", $$v);
              },
              expression: "newSubjects[index].collection_description"
            }
          })], 1), _c('b-form-group', {
            attrs: {
              "label-size": "sm",
              "disabled": _vm.isReadOnly
            },
            scopedSlots: _vm._u([{
              key: "label",
              fn: function fn() {
                return [_vm._v(" 分店關聯 "), _c('i', {
                  staticClass: "fa fa-question-circle ml-2 text-muted",
                  staticStyle: {
                    "font-size": "0.9rem"
                  },
                  attrs: {
                    "id": "branch-field-tooltip-carousel-".concat(index)
                  }
                })];
              },
              proxy: true
            }], null, true)
          }, [_c('b-form-select', {
            attrs: {
              "options": _vm.branchFieldOptions
            },
            model: {
              value: _vm.newSubjects[index].branch_field_id,
              callback: function callback($$v) {
                _vm.$set(_vm.newSubjects[index], "branch_field_id", $$v);
              },
              expression: "newSubjects[index].branch_field_id"
            }
          }), _c('b-tooltip', {
            attrs: {
              "target": "branch-field-tooltip-carousel-".concat(index),
              "triggers": "hover",
              "placement": "right"
            }
          }, [_vm._v(" 若資料集需與分店連動，請選擇分店欄位；若無需連動，則無須設定 ")])], 1)], 1)] : _vm._e(), newSubject.type === 'shop_selection' ? [_c('b-form-group', {
            attrs: {
              "label": "分店顯示類型 *",
              "label-size": "sm"
            }
          }, [_c('b-form-radio-group', {
            staticClass: "input-group",
            attrs: {
              "options": [{
                text: '所有分店',
                value: 'all'
              }, {
                text: '自訂分店',
                value: 'subset'
              }]
            },
            on: {
              "input": function input($event) {
                return _vm.handleShopSelectionPopulationChange(_vm.newSubjects[index]);
              }
            },
            model: {
              value: _vm.newSubjects[index].branch_population,
              callback: function callback($$v) {
                _vm.$set(_vm.newSubjects[index], "branch_population", $$v);
              },
              expression: "newSubjects[index].branch_population"
            }
          })], 1), _vm.deepGet(_vm.newSubjects[index], 'branch_population', 'all') === 'all' ? [_c('b-form-group', {
            attrs: {
              "label": "分店下拉選單來源",
              "label-size": "sm"
            }
          }, [_c('BranchProviderEditor', {
            ref: "branch-provider-editor-".concat(_vm.newSubjects[index]._id),
            refInFor: true,
            attrs: {
              "showBranchCode": _vm.newSubjects[index].show_branch_code
            },
            on: {
              "update:showBranchCode": function updateShowBranchCode($event) {
                return _vm.$set(_vm.newSubjects[index], "show_branch_code", $event);
              },
              "update:show-branch-code": function updateShowBranchCode($event) {
                return _vm.$set(_vm.newSubjects[index], "show_branch_code", $event);
              },
              "input": function input($event) {
                return _vm.handleShopSelectionProviderChange(_vm.newSubjects[index]);
              }
            },
            model: {
              value: _vm.newSubjects[index].branch_provider,
              callback: function callback($$v) {
                _vm.$set(_vm.newSubjects[index], "branch_provider", $$v);
              },
              expression: "newSubjects[index].branch_provider"
            }
          })], 1)] : _vm.deepGet(_vm.newSubjects[index], 'branch_population', 'all') === 'subset' ? [_c('BranchSubsetEditor', {
            staticClass: "mb-3",
            attrs: {
              "showBranchCode": _vm.newSubjects[index].show_branch_code
            },
            on: {
              "update:showBranchCode": function updateShowBranchCode($event) {
                return _vm.$set(_vm.newSubjects[index], "show_branch_code", $event);
              },
              "update:show-branch-code": function updateShowBranchCode($event) {
                return _vm.$set(_vm.newSubjects[index], "show_branch_code", $event);
              }
            },
            model: {
              value: _vm.newSubjects[index].branch_ids,
              callback: function callback($$v) {
                _vm.$set(_vm.newSubjects[index], "branch_ids", $$v);
              },
              expression: "newSubjects[index].branch_ids"
            }
          }), _c('b-form-group', {
            attrs: {
              "label": "是否顯示上層分店下拉",
              "label-size": "sm"
            }
          }, [_c('b-form-checkbox', {
            attrs: {
              "value": true,
              "unchecked-value": false
            },
            model: {
              value: _vm.newSubjects[index].show_parent_branch_options,
              callback: function callback($$v) {
                _vm.$set(_vm.newSubjects[index], "show_parent_branch_options", $$v);
              },
              expression: "newSubjects[index].show_parent_branch_options"
            }
          })], 1)] : _vm._e(), _c('b-form-group', {
            attrs: {
              "label": "分店下拉選單文字",
              "label-size": "sm"
            }
          }, [_c('b-form-input', {
            staticStyle: {
              "width": "200px"
            },
            attrs: {
              "type": "text"
            },
            model: {
              value: _vm.newSubjects[index].default_select_text,
              callback: function callback($$v) {
                _vm.$set(_vm.newSubjects[index], "default_select_text", $$v);
              },
              expression: "newSubjects[index].default_select_text"
            }
          })], 1), _c('b-form-group', {
            attrs: {
              "label": "是否顯示分店代號",
              "label-size": "sm"
            }
          }, [_c('b-form-checkbox', {
            attrs: {
              "value": true,
              "unchecked-value": false
            },
            model: {
              value: _vm.newSubjects[index].show_branch_code,
              callback: function callback($$v) {
                _vm.$set(_vm.newSubjects[index], "show_branch_code", $$v);
              },
              expression: "newSubjects[index].show_branch_code"
            }
          })], 1)] : _vm._e()];
        },
        proxy: true
      }, {
        key: "preview",
        fn: function fn() {
          return [_c('b-form-group', {
            staticClass: "mb-0",
            class: "form-group-".concat(newSubject.type),
            attrs: {
              "label": _vm.newSubjects[index].title,
              "description": _vm.newSubjects[index].memo
            }
          }, [newSubject.type === 'text' ? [_c('b-form-input', {
            attrs: {
              "placeholder": _vm.newSubjects[index].placeholder
            }
          })] : _vm._e(), newSubject.type === 'textarea' ? [_c('b-form-textarea', {
            attrs: {
              "placeholder": _vm.newSubjects[index].placeholder,
              "rows": _vm.newSubjects[index].rows
            }
          })] : _vm._e(), newSubject.type === 'select' ? [_c('b-form-select', {
            attrs: {
              "value": null,
              "options": _vm.previewOptions(index)
            }
          })] : _vm._e(), newSubject.type === 'radio' ? [_c('b-form-radio-group', {
            staticClass: "input-group"
          }, _vm._l(_vm.previewOptions(index), function (option) {
            return _c('b-form-radio', {
              key: option.value,
              attrs: {
                "value": option.value,
                "disabled": option.disabled
              }
            }, [option.staff_only ? [_c('div', {
              attrs: {
                "id": "radio-".concat(index, "-").concat(option.value)
              }
            }, [_vm._v(" " + _vm._s(option.text) + " "), _c('span', {
              staticClass: "fa fa-question-circle"
            })]), _c('b-tooltip', {
              attrs: {
                "target": "radio-".concat(index, "-").concat(option.value),
                "placement": "right"
              }
            }, [_vm._v("前台不會顯示這個選項")])] : [_vm._v(" " + _vm._s(option.text) + " ")]], 2);
          }), 1)] : _vm._e(), newSubject.type === 'checkbox' ? [_c('b-form-checkbox-group', {
            staticClass: "input-group",
            attrs: {
              "stacked": _vm.newSubjects[index].is_vertical
            }
          }, _vm._l(_vm.previewOptions(index), function (option) {
            return _c('b-form-checkbox', {
              key: option.value,
              attrs: {
                "value": option.value,
                "disabled": option.disabled
              }
            }, [option.staff_only ? [_c('div', {
              attrs: {
                "id": "checkbox-".concat(index, "-").concat(option.value)
              }
            }, [_vm._v(" " + _vm._s(option.text) + " "), _c('span', {
              staticClass: "fa fa-question-circle"
            })]), _c('b-tooltip', {
              attrs: {
                "target": "checkbox-".concat(index, "-").concat(option.value),
                "placement": "right"
              }
            }, [_vm._v("前台不會顯示這個選項")])] : [_vm._v(" " + _vm._s(option.text) + " ")]], 2);
          }), 1)] : _vm._e(), newSubject.type === 'datetime' ? [_vm.newSubjects[index].format === 'datetime' ? [_c('DynamicFormDateTimePicker', {
            attrs: {
              "placeholder-for-date": _vm.newSubjects[index].placeholder,
              "placeholder-for-time": _vm.newSubjects[index].placeholder,
              "daily-time": _vm.newSubjects[index].daily_time,
              "time-condition": _vm.newSubjects[index].time_condition,
              "start-time": _vm.newSubjects[index].start_time,
              "end-time": _vm.newSubjects[index].end_time,
              "slot-minutes": _vm.newSubjects[index].slot_minutes,
              "time-style": _vm.newSubjects[index].time_style,
              "date-condition": _vm.newSubjects[index].date_condition,
              "date-time-options": _vm.newSubjects[index].options,
              "custom-time-options": _vm.newSubjects[index].time_options || []
            }
          })] : _vm._e(), _vm.newSubjects[index].format === 'date' ? [_c('DynamicFormDatePicker', {
            attrs: {
              "placeholder": _vm.newSubjects[index].placeholder,
              "date-options": _vm.newSubjects[index].options,
              "date-type": _vm.newSubjects[index].date_condition
            }
          })] : _vm._e(), _vm.newSubjects[index].format === 'time' ? [_c('DynamicFormTimePicker', {
            attrs: {
              "placeholder": _vm.newSubjects[index].placeholder,
              "style-type": _vm.newSubjects[index].time_condition,
              "start-time": _vm.newSubjects[index].start_time,
              "end-time": _vm.newSubjects[index].end_time,
              "slot-minutes": _vm.newSubjects[index].slot_minutes,
              "time-style": _vm.newSubjects[index].time_style,
              "custom-time-options": _vm.newSubjects[index].time_options || []
            }
          })] : _vm._e()] : _vm._e(), newSubject.type === 'uploader' ? [_c('AppFileUploader')] : _vm._e(), newSubject.type === 'collection_select' ? [_vm.newSubjects[index].collection_presentation === 'select' ? [_c('b-form-select', {
            attrs: {
              "value": null,
              "options": _vm.previewCollectionItemOptions[_vm.newSubjects[index]._id]
            }
          })] : _vm._e(), _vm.newSubjects[index].collection_presentation === 'radio' ? [_c('b-form-radio-group', {
            staticClass: "input-group"
          }, _vm._l(_vm.previewCollectionItemOptions[_vm.newSubjects[index]._id], function (option) {
            return _c('b-form-radio', {
              key: option.value,
              attrs: {
                "value": option.value,
                "disabled": option.disabled
              }
            }, [_vm._v(" " + _vm._s(option.text) + " ")]);
          }), 1)] : _vm._e(), _vm.newSubjects[index].collection_presentation === 'checkbox' ? [_c('b-form-checkbox-group', {
            staticClass: "input-group"
          }, _vm._l(_vm.previewCollectionItemOptions[_vm.newSubjects[index]._id], function (option) {
            return _c('b-form-checkbox', {
              key: option.value,
              attrs: {
                "value": option.value,
                "disabled": option.disabled
              }
            }, [_vm._v(" " + _vm._s(option.text) + " ")]);
          }), 1)] : _vm._e()] : _vm._e(), newSubject.type === 'collection_carousel' ? [_c('CarouselSelection', {
            ref: "carousel-preview-".concat(_vm.newSubjects[index]._id),
            refInFor: true,
            attrs: {
              "value": null,
              "placeholder": _vm.newSubjects[index].placeholder,
              "candidate-fetcher": function candidateFetcher() {
                return _vm.fetchCollectionItemForCarousel(_vm.newSubjects[index]);
              }
            }
          })] : _vm._e(), newSubject.type === 'shop_selection' ? [_vm.deepGet(_vm.newSubjects[index], 'branch_population', 'all') === 'all' ? _c('ShopSelection', {
            ref: "shop-selection-".concat(_vm.newSubjects[index]._id),
            refInFor: true,
            attrs: {
              "branch-provider": _vm.newSubjects[index].branch_provider || '',
              "show-branch-code": _vm.newSubjects[index].show_branch_code || false,
              "placeholder": _vm.newSubjects[index].default_select_text || '',
              "api-source": "admin"
            }
          }) : _vm._e(), _vm.deepGet(_vm.newSubjects[index], 'branch_population', 'all') === 'subset' ? _c('ShopSubsetSelection', {
            ref: "shop-subset-selection-".concat(_vm.newSubjects[index]._id),
            refInFor: true,
            attrs: {
              "branch-ids": _vm.newSubjects[index].branch_ids || '',
              "show-parent-branches": _vm.newSubjects[index].show_parent_branch_options,
              "show-branch-code": _vm.newSubjects[index].show_branch_code || false,
              "placeholder": _vm.newSubjects[index].default_select_text || '',
              "api-source": "admin"
            }
          }) : _vm._e()] : _vm._e()], 2)];
        },
        proxy: true
      }], null, true)
    })], 1);
  }), 1)], 1), !_vm.isReadOnly ? _c('div', {
    staticClass: "subject-type-menu mt-3"
  }, [_c('span', {
    staticClass: "subject-type-menu__icon mdi mdi-24px mdi-plus"
  }), _c('div', {
    staticClass: "subject-type-menu__button-wrapper"
  }, [_c('b-button', {
    staticClass: "subject-type-menu__create-button",
    attrs: {
      "variant": "inverse-primary"
    },
    on: {
      "click": function click($event) {
        return _vm.createNewSubject('text');
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-18px",
    class: _vm.subjectTypeIcon('text')
  }), _vm._v(" 單行文字 ")]), _c('b-button', {
    staticClass: "subject-type-menu__create-button",
    attrs: {
      "variant": "inverse-primary"
    },
    on: {
      "click": function click($event) {
        return _vm.createNewSubject('textarea');
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-18px",
    class: _vm.subjectTypeIcon('textarea')
  }), _vm._v(" 多行文字 ")]), _c('b-button', {
    staticClass: "subject-type-menu__create-button",
    attrs: {
      "variant": "inverse-primary"
    },
    on: {
      "click": function click($event) {
        return _vm.createNewSubject('radio');
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-18px",
    class: _vm.subjectTypeIcon('radio')
  }), _vm._v(" 單選題 ")]), _c('b-button', {
    staticClass: "subject-type-menu__create-button",
    attrs: {
      "variant": "inverse-primary"
    },
    on: {
      "click": function click($event) {
        return _vm.createNewSubject('checkbox');
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-18px",
    class: _vm.subjectTypeIcon('checkbox')
  }), _vm._v(" 多選題 ")]), _c('b-button', {
    staticClass: "subject-type-menu__create-button",
    attrs: {
      "variant": "inverse-primary"
    },
    on: {
      "click": function click($event) {
        return _vm.createNewSubject('select');
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-18px",
    class: _vm.subjectTypeIcon('select')
  }), _vm._v(" 下拉選單 ")]), _c('b-button', {
    staticClass: "subject-type-menu__create-button",
    attrs: {
      "variant": "inverse-primary"
    },
    on: {
      "click": function click($event) {
        return _vm.createNewSubject('datetime');
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-18px",
    class: _vm.subjectTypeIcon('datetime')
  }), _vm._v(" 日期與時間 ")]), ['booking', 'collection'].includes(_vm.formType) ? _c('b-button', {
    staticClass: "subject-type-menu__create-button",
    attrs: {
      "variant": "inverse-primary"
    },
    on: {
      "click": function click($event) {
        return _vm.createNewSubject('uploader');
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-18px",
    class: _vm.subjectTypeIcon('uploader')
  }), _vm._v(" 檔案上傳 ")]) : _vm._e(), _vm.formType === 'booking' ? _c('b-button', {
    staticClass: "subject-type-menu__create-button",
    attrs: {
      "variant": "inverse-primary"
    },
    on: {
      "click": function click($event) {
        return _vm.createNewSubject('collection_select');
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-18px",
    class: _vm.subjectTypeIcon('collection_select')
  }), _vm._v(" 資料集關聯 ")]) : _vm._e(), _vm.formType === 'booking' ? _c('b-button', {
    staticClass: "subject-type-menu__create-button",
    attrs: {
      "variant": "inverse-primary"
    },
    on: {
      "click": function click($event) {
        return _vm.createNewSubject('collection_carousel');
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-18px",
    class: _vm.subjectTypeIcon('collection_carousel')
  }), _vm._v(" 資料集開窗 ")]) : _vm._e(), _vm.formType === 'booking' ? _c('b-button', {
    staticClass: "subject-type-menu__create-button",
    attrs: {
      "variant": "inverse-primary"
    },
    on: {
      "click": function click($event) {
        return _vm.createNewSubject('shop_selection');
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-18px",
    class: _vm.subjectTypeIcon('shop_selection')
  }), _vm._v(" 分店 ")]) : _vm._e()], 1)]) : _vm._e(), !_vm.isReadOnly ? _c('div', {
    staticClass: "mt-3 d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('cancel');
      }
    }
  }, [_vm._v(" 返回 ")]), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.outputSubjects
    }
  }, [_vm._v(" 儲存 ")])], 1) : _vm._e(), _c('b-modal', {
    attrs: {
      "id": "export-subjects-json",
      "title": "題目 JSON 輸出",
      "cancel-title": "取消"
    }
  }, [_c('b-form-textarea', {
    model: {
      value: _vm.exportSubjectsJson,
      callback: function callback($$v) {
        _vm.exportSubjectsJson = $$v;
      },
      expression: "exportSubjectsJson"
    }
  })], 1), _c('b-modal', {
    attrs: {
      "id": "import-subjects-json",
      "title": "匯入題目 JSON",
      "cancel-title": "取消",
      "ok-title": "匯入"
    },
    on: {
      "ok": _vm.saveImportSubjects
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "rows": "10"
    },
    model: {
      value: _vm.importSubjectsJson,
      callback: function callback($$v) {
        _vm.importSubjectsJson = $$v;
      },
      expression: "importSubjectsJson"
    }
  }), _c('p', [_vm._v("一但匯入，將會將目前題目全數以匯入的 JSON 覆蓋，請確認")]), _c('p', [_vm._v("本編輯器可支援 member_register.member_fields, survey_subjects")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }